<template>
    <section class="sticky top-0 bg-white z-50">
        <header class="w-full relative p-5 m-auto">
            <div class="flex justify-center">
                <router-link :to="'/'">
                    <img class="w-36 md:w-auto" src="@/assets/img/swu_logo.svg" alt="logo">
                </router-link>
            </div>
            <div class="absolute top-1/2 left-auto right-[32px] -translate-y-[40%]">
                <button @click="openModal" id="header_menu">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 md:w-auto" width="35.27" height="25.07" viewBox="0 0 35.27 25.07">
                        <path d="m1.5,1.5h32.27" style="fill: none; stroke: #414141; stroke-linecap: round; stroke-width: 3px;"/>
                        <path d="m1.5,12.54h32.27" style="fill: none; stroke: #414141; stroke-linecap: round; stroke-width: 3px;"/>
                        <path d="m1.5,23.57h32.27" style="fill: none; stroke: #414141; stroke-linecap: round; stroke-width: 3px;"/>
                    </svg>
                </button>
            </div>
        </header>
        
        <dialog ref="drawerRef" @close="onClose" class="left-auto right-0 w-5/6 h-full md:w-screen max-w-full max-h-full m-0 p-0 drawer">
            <form method="dialog" class="flex flex-col h-full">
                <header class="relative grid w-full justify-between m-auto drawer_header px-6 py-5 md:px-8">
                    <!-- 프로필 영역-->
                    <div class="profile_wrapper flex items-center gap-3">
                      <div class="flex items-center" v-if="my_idx <= 0">  
                        <div class="text-white mr-2"><b>로그인</b>하세요</div>
                        <button type="button" class="md:block notosans text-sm text-white border border-white rounded py-1 px-2 mt-[2px]" @click="goLogin"> 로그인 </button>
                      </div>
                      <div class="flex items-center " v-if="my_idx > 0">
                        <div class="profile_pic">
                            <!-- 이미지 설정 안 돼있을 경우 : swu_profile_noimage.jpg(500x500) -->
                            <img :src="profile_image" alt="프로필 이미지">
                        </div>
                        <h1 class="mx-2">{{my_name}}</h1>
                        <button class="md:block hidden notosans text-sm text-white border border-white rounded py-1 px-2 mt-[2px]" @click="logout">
                            로그아웃
                        </button>
                      </div>
                    </div>

                    <div class="flex gap-3 md:gap-6 profile_btn_wrapper">
                        <button @click="this.$router.push('/profile')" v-if="my_idx > 0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39">
                                <path d="m19.5,25.29c-2.34,0-4.45-1.41-5.35-3.57-.9-2.16-.4-4.65,1.25-6.31,1.66-1.66,4.15-2.15,6.31-1.25,2.16.89,3.57,3.01,3.57,5.35,0,3.2-2.59,5.79-5.79,5.79Zm0-13.41c-3.08,0-5.86,1.85-7.04,4.7-1.18,2.85-.53,6.12,1.65,8.3,2.18,2.18,5.45,2.83,8.3,1.65,2.85-1.18,4.7-3.96,4.7-7.04,0-4.21-3.41-7.62-7.62-7.62Z" style="fill: #fff;"/>
                                <path d="m37.17,22.24c0,.17-.14.3-.3.3h-2.72c-.91,0-1.71.57-2.01,1.43-.16.44-.34.87-.54,1.3-.39.82-.23,1.79.41,2.44l1.92,1.92c.12.12.12.31,0,.43l-3.88,3.87c-.12.12-.31.12-.43,0l-1.92-1.92c-.64-.64-1.62-.81-2.44-.41-.42.2-.86.38-1.3.54-.85.3-1.43,1.11-1.43,2.01v2.72c0,.17-.14.3-.3.3h-5.48c-.17,0-.3-.14-.3-.3v-2.72c0-.91-.57-1.71-1.43-2.01-.44-.16-.87-.34-1.3-.54-.82-.39-1.79-.23-2.44.41l-1.92,1.92c-.12.12-.31.12-.43,0l-3.87-3.88c-.12-.12-.12-.31,0-.43l1.92-1.92c.64-.64.81-1.62.41-2.44-.2-.42-.38-.86-.54-1.3-.3-.85-1.11-1.42-2.01-1.42h-2.72c-.17,0-.3-.14-.3-.3v-5.48c0-.17.14-.3.3-.3h2.72c.91,0,1.71-.57,2.01-1.43.16-.44.34-.87.54-1.3.39-.82.23-1.79-.41-2.44l-1.92-1.92c-.12-.12-.12-.31,0-.43l3.88-3.87c.12-.12.31-.12.43,0l1.92,1.92c.64.64,1.62.81,2.44.41.42-.2.86-.38,1.3-.54.85-.3,1.42-1.11,1.42-2.01v-2.72c0-.17.14-.3.3-.3h5.48c.17,0,.3.14.3.3v2.72c0,.91.57,1.71,1.43,2.01.44.16.87.34,1.3.54.82.39,1.79.23,2.44-.41l1.92-1.92c.12-.12.31-.12.43,0l3.88,3.88c.12.12.12.31,0,.43l-1.92,1.92c-.64.64-.81,1.62-.41,2.44.2.42.38.86.54,1.3.3.85,1.11,1.42,2.01,1.43h2.71c.17,0,.3.14.3.3v5.47Zm-.3-7.62h-2.72c-.13,0-.24-.08-.29-.21-.18-.5-.38-1-.61-1.48-.06-.12-.04-.26.06-.35l1.92-1.92c.83-.83.83-2.18,0-3.02l-3.88-3.88c-.83-.83-2.18-.83-3.02,0l-1.92,1.92c-.09.09-.23.11-.35.06-.48-.23-.97-.43-1.48-.61-.12-.04-.21-.16-.21-.29v-2.72c0-1.18-.96-2.13-2.13-2.13h-5.48c-1.18,0-2.13.96-2.13,2.13v2.72c0,.13-.08.24-.21.29-.5.18-1,.38-1.48.61-.12.06-.26.04-.35-.06l-1.92-1.92c-.83-.83-2.18-.83-3.02,0l-3.88,3.88c-.83.83-.83,2.18,0,3.02l1.92,1.92c.09.09.11.23.06.35-.23.48-.43.97-.61,1.48-.04.12-.16.21-.29.21h-2.72c-1.18,0-2.13.96-2.13,2.13v5.48c0,1.18.96,2.13,2.13,2.13h2.72c.13,0,.24.08.29.21.18.5.38,1,.61,1.48.06.12.04.26-.06.35l-1.92,1.92c-.83.83-.83,2.18,0,3.02l3.88,3.88c.83.83,2.18.83,3.02,0l1.92-1.92c.09-.09.23-.11.35-.06.48.23.97.43,1.48.61.12.04.21.16.21.29v2.72c0,1.18.96,2.13,2.13,2.13h5.48c1.18,0,2.13-.96,2.13-2.13v-2.72c0-.13.08-.24.21-.29.5-.18,1-.38,1.48-.61.12-.06.26-.04.35.06l1.92,1.92c.83.83,2.18.83,3.02,0l3.88-3.88c.83-.83.83-2.18,0-3.02l-1.92-1.92c-.09-.09-.11-.23-.06-.35.23-.48.43-.97.61-1.48.04-.12.16-.21.29-.21h2.72c1.18,0,2.13-.96,2.13-2.13v-5.48c0-1.18-.96-2.13-2.13-2.13Z" style="fill: #fff;"/>
                            </svg>
                        </button>
                        <button value="cancel">
                            <svg xmlns="http://www.w3.org/2000/svg" width="31.38" height="34.83" viewBox="0 0 31.38 34.83">
                                <line x1="30.48" y1=".9" x2=".9" y2="33.93" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-width: 1.8px;"/>
                                <line x1=".9" y1=".9" x2="30.48" y2="33.93" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-width: 1.8px;"/>
                              </svg>
                        </button>
                    </div>
                </header>

                <section class="flex flex-col justify-between drawer_menu_container">
                    <ul class="drawer_menu_wrapper w-full max-w-[945px] md:mx-auto bg-white overflow-y-auto lg:p-10">
                        <li class="flex items-center">
                            <VToggle label="SWU LIFE 활동" class="drawer_menu w-full">
                                <div class="toggle-content lg:flex lg:gap-x-12">
                                    <a href="/swu_life" class="drawer_a">SWU LIFE란?</a>
                                    <a href="/swu_class" class="drawer_a">SWU LIFE 활동</a>
                                </div>
                            </VToggle>
                        </li>
                        <li class="flex items-center">
                            <VToggle label="바롬 Archive" class="drawer_menu w-full">
                                <div class="toggle-content lg:flex lg:gap-x-12">
                                    <a href="/list/barom1" class="drawer_a">바롬페스티벌</a>
                                    <a href="/list/barom2" class="drawer_a">우리가 뽑은 팀</a>
                                </div>
                            </VToggle>
                        </li>
                        <li class="flex items-center">
<!--                            <VToggle label="우리들의 이야기" class="drawer_menu w-full">-->
                            <VToggle label="슈미션" class="drawer_menu w-full">
                                <div class="toggle-content lg:flex lg:gap-x-12">
                                    <a href="/list/bd1" class="drawer_a">슈미션 활동</a>
                                    <a href="/list/bd2" class="drawer_a">슈미션 결과물</a>
<!--                                    <a href="/list/bd3" class="drawer_a">Topic Club</a>-->
                                </div>
                            </VToggle>
                        </li>
                        <li class="flex items-center">
                            <VToggle label="슈스페셜" class="drawer_menu w-full">
                                <div class="toggle-content lg:flex lg:gap-x-12">
                                    <a href="/list/special1" class="drawer_a">슈스페셜 소개</a>
                                    <a href="/list/special2" class="drawer_a">갤러리</a>
                                    <a href="/list/feeling" class="drawer_a">활동 후 소감</a>
<!--                                    <a href="/list/check" class="drawer_a">출석체크</a>-->
                                </div>
                            </VToggle>
                        </li>

                        <li class="flex items-center">
                            <VToggle label="슈ABC" class="drawer_menu w-full">
                                <div class="toggle-content lg:flex lg:gap-x-12">
                                    <a href="/list/abc_about" class="drawer_a">슈ABC 소개</a>
                                    <a href="/list/abc_photo" class="drawer_a">차수별 사진</a>
<!--                                    <a href="/list/check" class="drawer_a">출석체크</a>-->
                                </div>
                            </VToggle>
                        </li>

                        <li class="flex items-center">
                            <VToggle label="게시판" class="drawer_menu w-full">
                                <div class="toggle-content lg:flex lg:gap-x-12">
                                    <a href="/faq" class="drawer_a">FAQ</a>
                                    <a href="/qna" class="drawer_a">질의응답</a>
                                </div>
                            </VToggle>
                        </li>
                    </ul>
                    
                    <div class="hidden md:block drawer_menu_copy">
                        <div class="copy_wrapper flex items-center justify-center py-10">
                            <svg xmlns="http://www.w3.org/2000/svg" width="315.49" height="62.7" viewBox="0 0 315.49 62.7" class="swu_txts min-w-[646px] hidden xl:block h-auto ml-auto mr-0 mix-blend-multiply">
                                <path d="m15.63,15.68c0-2.56,2.09-3.61,5.11-3.61,2.81,0,5.11,1.38,5.11,3.94v4.14h14.92v-5.98C40.77,4.12,31.76.5,20.74.5S.72,4.12.72,14.17v4.93c0,7.82,2.81,11.63,15.49,15.77,8.57,2.82,9.8,3.94,9.8,10.12v1.64c0,2.56-2.52,3.94-5.33,3.94s-5.26-1.38-5.26-3.94v-6.7H.5v8.61c0,10.05,9.01,13.67,20.03,13.67s20.39-3.61,20.39-13.67v-6.18c0-9.59-.94-12.94-15.85-18.2-7.64-2.69-9.44-3.61-9.44-6.04v-2.43ZM69,1.82l-5.91,39.42L58.19,1.82h-14.62l8.28,59.06h18.8l4.9-29.7,5.26,29.7h18.66L107.76,1.82h-14.19l-5.33,39.42L82.04,1.82h-13.04Zm67.06,44.55c0,2.56-2.02,3.94-4.83,3.94s-4.83-1.38-4.83-3.94V1.82h-15.2v46.71c0,10.05,9.01,13.67,20.03,13.67s20.03-3.61,20.03-13.67V1.82h-15.2v44.55ZM194.48,1.82h-15.85v59.06h35.73v-12.48h-19.88V1.82Zm23.12,0v59.06h15.85V1.82h-15.85Zm36.74,59.06v-24.17h19.88v-11.5h-19.88v-10.91h20.6V1.82h-35.74v59.06h15.13Zm60.65,0v-12.16h-21.32v-12.08h19.88v-11.5h-19.88v-11.17h20.6V1.82h-35.73v59.06h36.45,0Z" style="fill: #fff; fill-rule: evenodd; stroke: #eeeeee; stroke-linejoin: round;"/>
                            </svg>
                            <p>copyright 2023. All Rights Reserved</p>
                        </div>
                    </div>

                    <div class="md:hidden drawer_menu_so"  @click="logout" v-if="my_idx > 0">
                        <!-- <button type="button" v-if="my_idx <= 0" @click="this.$router.push('/login')"> 로그인 </button> -->
                        <button class="flex items-center gap-1">
                            로그아웃
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18.05" viewBox="0 0 18 18.05">
                                <path d="m12.82.19v1.19h2.96l-7.04,7.04.84.84,7.04-7.04v2.96h1.19V.19h-4.99Zm2.74,9.39h1.19v6.35c0,1.07-.87,1.93-1.93,1.93H2.12c-1.07,0-1.93-.87-1.93-1.93V3.22c0-1.07.87-1.93,1.93-1.93h6.35v1.19H2.12c-.41,0-.74.33-.74.74v12.71c0,.41.33.74.74.74h12.7c.41,0,.74-.33.74-.74v-6.35Z" style="fill: #a1a1a1;"/>
                                <path d="m14.82,18.05H2.12c-1.17,0-2.12-.95-2.12-2.12V3.22C0,2.06.95,1.11,2.12,1.11h6.54v1.56H2.12c-.31,0-.56.25-.56.56v12.71c0,.31.25.56.56.56h12.7c.31,0,.56-.25.56-.56v-6.54s1.56,0,1.56,0v6.54c0,1.17-.95,2.12-2.12,2.12ZM2.12,1.48c-.96,0-1.75.78-1.75,1.75v12.71c0,.96.79,1.75,1.75,1.75h12.7c.96,0,1.75-.79,1.75-1.75v-6.17h-.82v6.17c0,.51-.42.93-.93.93H2.12c-.51,0-.93-.42-.93-.93V3.22c0-.51.42-.92.93-.93h6.17v-.82H2.12Zm7.47,8.04l-1.1-1.1L15.33,1.56h-2.69V0h5.36v5.36h-1.56v-2.69l-6.85,6.85Zm-.58-1.1l.58.58,7.22-7.22v3.22h.82V.37h-4.62v.82h3.22l-7.22,7.22Z" style="fill: #a1a1a1;"/>
                            </svg>
                        </button>
                    </div>
                </section>
            </form>
        </dialog>

    </section>
</template>

<script>
import { ref } from "vue";

export default {
  name: "nav_header",
  data() {
    return {
      my_idx: 0,
      my_name: "",
      // profile_image: "@/assets/img/swu_profile_noimage.jpg",
      profile_image: require("@/assets/img/swu_profile_noimage.jpg"),
    };
  },

  setup() {
      const drawerRef = ref(null);
      const body = document.body;

      return { drawerRef, openModal, onClose };

      function openModal() {
          if (typeof drawerRef.value.showModal === "function") {
              drawerRef.value.showModal();
              body.style.overflow = 'hidden';
          }
      }

      function onClose() {
          const { returnValue } = drawerRef.value;
          if (returnValue === "cancel") {
              body.style.overflow = 'auto';
          }
      }
  },

  methods: {
    goLogin(){
      document.location.href = "/login";
    },
    getMyInfo() {
      const me = this;
      const url = "/api/api.php";

      try {
        const formData = new FormData;
        formData.append('mode', 'getMyInfo');
        me.axios.post(url, formData, {
          headers: {
            'authorization2':localStorage.getItem('access_token')
          }
        }).then(function (res) {
          if( res.data.err === 0 ){
            me.my_idx = res.data.info.idx;
            me.my_name = res.data.info.name;
          }
          else {
            // const err_msg = `[${res.data.err}] ${res.data.err_msg}`;
            // alert(err_msg);
            return false;
          }
        })
      } catch (e) {
        console.log(e);
      }
    },

    logout(){
      localStorage.removeItem("access_token");
      document.location.href = "/";
    }

  },
  mounted() {

    const token = localStorage.getItem('access_token');
    if( token ){
      this.getMyInfo();
    }

  }

};

</script>
